import { type FC } from 'react';
import { Badge } from '@mantine/core';
import { formatPayoutTrader, payoutTraderStatusColors, type PayoutTraderStatus } from '~/entities/payout';

interface TraderStatusBadgeProps {
    status?: PayoutTraderStatus;
}

export const TraderStatusBadge: FC<TraderStatusBadgeProps> = ({ status }) => {
    if (!status) {
        return null;
    }

    return (
        <Badge
            fz='xs'
            color={payoutTraderStatusColors[status]}
        >
            {formatPayoutTrader.status(status)}
        </Badge>
    );
};
